<template>
  <div class="comp-find-field-condition">
    <div class="page-find-records-title" v-if="props.isQueryAll">
      <p>
        <span>{{ $t('设置筛选条件') }}</span>
        <jw-tooltip :content="$t('筛选该操作执行时符合条件的记录')">
          <icon-question-circle :size="16" />
        </jw-tooltip>
      </p>
      <p>
        <span>{{ $t('符合以下') }}</span>
        <jw-select v-model="data.form.queryAll" size="mini" :placeholder="$t('请选择')" :style="{ width: '80px' }" class="page-find-records-select" :options="data.selected"></jw-select>
        <span>{{ $t('筛选条件') }}</span>
      </p>
    </div>
    <div class="page-find-records-content" ref="findRecordsContent">
      <jw-space direction="vertical" fill>
        <jw-form :model="data.form" ref="formRef" auto-label-width>
          <li class="rule-filter-item-sub" v-for="(sub, index) in data.form.conditions" :key="index">
            <jw-row :gutter="8" align="center">
              <jw-col :span="data.form.conditions.length > 1 ? 7 : 8">
                <jw-select class="rule-form-item-sub-select-field" v-model="sub.field" :placeholder="$t('请选择')" @change="changeChild($event, index)" allow-search :field-names="data.fieldNames" :trigger-props="{ updateAtScroll: true }">
                  <jw-option v-for="item in data.leadsFieldList" :key="item.fieldKey" :value="item.fieldKey" :title="item.fieldName">{{ item.fieldName }}</jw-option>
                </jw-select>
              </jw-col>
              <jw-col :span="6">
                <jw-select class="rule-form-item-sub-filter" v-model="sub.operation" :placeholder="$t('请选择')" @change="changeChildTwo($event, index)" allow-search :trigger-props="{ updateAtScroll: true }">
                  <jw-option v-for="item in getConditionFilterType(sub.field)" :key="item.value" :value="item?.value" :title="item?.label">{{ item?.label }}</jw-option>
                </jw-select>
              </jw-col>
              <!-- 2,3 -->
              <jw-col :span="data.form.conditions.length > 1 ? 9 : 10">
                <!-- 4,5 -->
                <template v-if="checkSelectFieldType(data.objList[sub.field]?.fieldType || data.objList[sub.field]?.business?.fieldType)">
                  <fh-select v-if="!(sub.operation == 'null' || sub.operation == 'not_null')" :placeholder="$t('请选择')" :multiple="checkMultiple(sub)" class="rule-form-item-sub-select mapping-select" v-model.trim="sub.value" :options="getOptions(data, sub)">
                    <template #label="{ data }">
                      <ly-show-filters showType="firstFilter" :showInner="data.label" />
                    </template>
                  </fh-select>

                  <!-- <jw-select v-if="!(sub.operation == 'null' || sub.operation == 'not_null')" :max-tag-count="1" :placeholder="$t('请选择')" :multiple="checkMultiple(sub)" class="rule-form-item-sub-select mapping-select" v-model.trim="sub.value" allow-search :trigger-props="{ updateAtScroll: true }">
                    <template #label="{ data }">
                      <ly-show-filters showType="firstFilter" :showInner="data.label" />
                    </template>
                    <jw-option v-for="item in getOptions(data, sub)" :key="item.value" :title="item.label" :value="item.value">{{ item.label }}</jw-option>
                  </jw-select> -->
                  <div style="width: 0" v-else-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                </template>
                <!-- 6 人员选择是一个单框与角色权限中的添加人员一样 -->
                <template v-else-if="data.objList[sub.field]?.fieldType == 6 || data.objList[sub.field]?.business?.fieldType == 6">
                  <template v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                    <fh-person position="bl" :maxTagCount="1" :item="sub" :multiple="sub.operation === 'equals' || sub.operation === 'not_equals' ? false : true" @cb="getValUser($event, index, i)"> </fh-person>
                    <!-- <xl-tree-member-modal :tree="userTree" @cb="getValUser($event, index, i)" :multipleDep="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" :user="sub.userList">
                      <jw-input-tag v-model="sub.userDept" :max-tag-count="1" class="rule-form-item-sub-select mapping-tag" readonly :placeholder="$t('请选择')" />
                    </xl-tree-member-modal> -->
                  </template>
                  <div style="width: 0" v-else></div>
                </template>
                <!-- 7数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
                <template v-else-if="(data.objList[sub.field]?.fieldType === 7 && sub.operation != 'null' && sub.operation != 'not_null') || (data.objList[sub.field]?.business?.fieldType == 7 && sub.operation != 'null' && sub.operation != 'not_null')">
                  <div style="width: 0" v-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                  <jw-input-number v-else class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, data.objList[sub.field])" :formatter="(event) => isShowThousandFormatter(event, data.objList[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(data.objList[sub.field], precisionNum)" />
                </template>
                <!-- 日期格式 -->
                <template v-else-if="data.objList[sub.field]?.fieldType == 8 || data.objList[sub.field]?.business?.fieldType == 8">
                  <div class="rule-form-item-sub-select">
                    <xl-date-variable :objList="data?.objList[sub.field]" :record="sub" @cb="getDateVariable($event, index)"></xl-date-variable>
                  </div>
                </template>
                <!-- 9日期范围 -->
                <template v-else-if="(data.objList[sub.field]?.fieldType === 9 && sub.operation != 'null' && sub.operation != 'not_null') || (data.objList[sub.field]?.business?.fieldType == 9 && sub.operation != 'null' && sub.operation != 'not_null')">
                  <jw-range-picker v-if="data.objList[sub.field]?.fieldExt == '0' || data.objList[sub.field]?.business?.fieldExt == '0'" v-model="sub.value" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" />
                  <jw-range-picker v-else-if="data.objList[sub.field]?.fieldExt == '1' || data.objList[sub.field]?.business?.fieldExt == '1'" class="rule-form-item-sub-select" v-model="sub.value" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" :trigger-props="{ updateAtScroll: true }" />
                  <jw-range-picker v-else v-model="sub.value" class="rule-form-item-sub-select" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" :trigger-props="{ updateAtScroll: true }" />
                </template>
                <!-- 10 级联选择器 :path-mode="true"-->
                <template v-else-if="data.objList[sub.field]?.fieldType == 10 || data.objList[sub.field]?.business?.fieldType == 10">
                  <jw-cascader :path-mode="true" v-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" class="rule-form-item-sub-select" :options="JSON.parse(data.objList[sub.field]?.fieldType != 21 ? data.objList[sub.field]?.fieldExt : data.objList[sub.field]?.business?.fieldExt)" allow-search v-model="sub.value" :placeholder="$t('请选择')" />
                  <jw-cascader :path-mode="true" v-else-if="sub.operation == 'in' || sub.operation == 'not_in'" class="rule-form-item-sub-select" :options="JSON.parse(data.objList[sub.field]?.fieldType != 21 ? data.objList[sub.field]?.fieldExt : data.objList[sub.field]?.business?.fieldExt)" allow-search v-model="sub.value" :placeholder="$t('请选择')" multiple />
                  <div style="width: 0" v-else-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                </template>
                <!-- 16 金额 -->
                <template v-else-if="data.objList[sub.field]?.fieldType === 16 || data.objList[sub.field]?.business?.fieldType == 16">
                  <jw-input-number v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, data.objList[sub.field])" :formatter="(event) => isShowThousandFormatter(event, data.objList[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(data.objList[sub.field], precisionNum)" />
                  <div v-else style="width: 0"></div>
                </template>
                <!-- 22 部门 -->
                <template v-else-if="data.objList[sub.field]?.fieldType == 22 || data.objList[sub.field]?.business?.fieldType == 22">
                  <xl-tree-member-modal :tree="departTree" v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" @cb="getValUser($event, index, i)" :multipleDep="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" :depart="sub.departList">
                    <jw-input-tag v-model="sub.userDept" :max-tag-count="1" class="rule-form-item-sub-select mapping-tag" readonly :placeholder="$t('请选择')" />
                  </xl-tree-member-modal>
                  <div style="width: 0" v-else></div>
                </template>
                <!-- 23百分比 查找关联-->
                <template v-else-if="data.objList[sub.field]?.fieldType == 23 || data.objList[sub.field]?.business?.fieldType == 23">
                  <jw-input-number v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" class="rule-form-item-item-select percentage" v-model="sub.value" :placeholder="$t('请输入')" @input="(event) => getPrecisionNum(event, data.objList[sub.field])" :precision="getPrecision(data.objList[sub.field], precisionNum)"> <template #append> % </template> </jw-input-number>
                  <div style="width: 0" v-else></div>
                </template>
                <!-- 24计算字段 -->
                <template v-else-if="data.objList[sub.field]?.fieldType == 24 || data.objList[sub.field]?.business?.fieldType == 24">
                  <template v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                    <!-- 计算字段的fieldExt的type=5 :数字（汇总累计）type=7 :数字-->
                    <jw-input-number v-if="(tools.isJSON(data.objList[sub.field]?.fieldExt) && [5, 7].includes(JSON.parse(data.objList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(data.objList[sub.field]?.business?.fieldExt) && [5, 7].includes(JSON.parse(data.objList[sub.field]?.business?.fieldExt)?.type))" class="rule-form-item-sub-select" v-model="sub.value" @input="(event) => getPrecisionNum(event, data.objList[sub.field])" :formatter="(event) => isShowThousandFormatter(event, data.objList[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(data.objList[sub.field], precisionNum, true)" :placeholder="$t('请选择')" />
                    <!-- 计算字段的fieldExt的type=6 :金额(汇总金额) type=16 :金额 -->
                    <jw-input-number v-else-if="(tools.isJSON(data.objList[sub.field]?.fieldExt) && [6, 16].includes(JSON.parse(data.objList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(data.objList[sub.field]?.business?.fieldExt) && [6, 16].includes(JSON.parse(data.objList[sub.field]?.business?.fieldExt)?.type))" class="rule-form-item-sub-select" v-model="sub.value" @input="(event) => getPrecisionNum(event, data.objList[sub.field])" :formatter="(event) => isShowThousandFormatter(event, data.objList[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(data.objList[sub.field], precisionNum, true)" :placeholder="$t('请选择')" />
                    <!-- 计算字段的fieldExt的type=0 :文本 -->
                    <jw-input v-else-if="(tools.isJSON(data.objList[sub.field]?.fieldExt) && [0].includes(JSON.parse(data.objList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(data.objList[sub.field]?.business?.fieldExt) && [0].includes(JSON.parse(data.objList[sub.field]?.business?.fieldExt)?.type))" v-model.trim="sub.value" :placeholder="$t('请输入')" class="rule-form-item-sub-select" />
                    <!-- 计算字段的fieldExt的type=23 :百分比 -->
                    <jw-input-number v-else-if="(tools.isJSON(data.objList[sub.field]?.fieldExt) && [23].includes(JSON.parse(data.objList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(data.objList[sub.field]?.business?.fieldExt) && [23].includes(JSON.parse(data.objList[sub.field]?.business?.fieldExt)?.type))" class="rule-form-item-sub-select percentage" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, data.objList[sub.field])" :precision="getPrecision(data.objList[sub.field], precisionNum, true)">
                      <template #append> % </template>
                    </jw-input-number>
                    <!-- 计算字段的fieldExt的type=8 :日期 -->
                    <template v-else-if="(tools.isJSON(data.objList[sub.field]?.fieldExt) && [8].includes(JSON.parse(data.objList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(data.objList[sub.field]?.business?.fieldExt) && [8].includes(JSON.parse(data.objList[sub.field]?.business?.fieldExt)?.type))">
                      <xl-date-variable :objList="data?.objList[sub.field]" :record="sub" @cb="getDateVariable($event, index)"></xl-date-variable>
                    </template>
                  </template>
                  <div v-else style="width: 0"></div>
                </template>
                <!-- 单行文本 obj[sub.field] -->
                <template v-else>
                  <jw-input v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" v-model.trim="sub.value" :placeholder="$t('请输入')" class="rule-form-item-sub-select" />
                  <div v-else style="width: 0"></div>
                </template>
              </jw-col>
              <jw-col :span="data.form.conditions.length > 1 ? 2 : 0"> <icon-minus-circle class="del-item" :size="20" v-if="data.form.conditions.length > 1" @click="deleteItem(index)" /></jw-col>
              <!-- </jw-space> -->
            </jw-row>
          </li>
        </jw-form>
        <jw-button type="outline" size="mini" @click="addCondition">
          <template #icon> <icon-plus /> </template>
          {{ $t('添加条件') }}
        </jw-button>
      </jw-space>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { reactive, ref, inject, computed, watch, nextTick } from 'vue';
import { setService } from '@/api/';
import { tools } from '@/utils/tools';
import dayjs from 'dayjs';
import FhSelect from '@/components/fh-select/fh-select.vue';

// 精度
import useThousandOption from '@/hooks/thousand';
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();

import { useUserStore } from '@/store';
const { userInfo } = useUserStore(); //用户信息
const { t } = useI18n();
console.log('1-开始创建组件-setup');
const emits = defineEmits(['cb']);
const props = defineProps({
  record: {
    type: Object,
    default: () => {}
  },
  isQueryAll: {
    type: Boolean,
    default: () => false
  }
});

// 判断下拉类型
const checkSelectFieldType = (fieldType) => {
  return [2, 3, 4, 5].includes(fieldType);
};

// 获取下拉列表
const getOptions = (data, sub) => {
  const extInfo = data.objList[sub.field]?.fieldType != 21 ? data.objList[sub.field]?.fieldExt : data.objList[sub.field]?.business?.fieldExt;
  return tools.isJSON(extInfo) ? JSON.parse(extInfo) : extInfo;
};

// 判断是否多选
const checkMultiple = (sub) => {
  if (sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == '') {
    return false;
  }
  return true;
};

// 获取条件下拉选择
const getConditionFilterType = (field) => {
  // data.filterType[data.objList[sub.field]?.fieldType != 21 ? data.objList[sub.field]?.fieldType : data.objList[sub.field]?.business?.fieldType]
  let list = [];
  const fieldType = data.objList[field]?.fieldType;
  if (fieldType == 21) {
    if (data.objList[field]?.business?.fieldType == 24) {
      const businessFieldExt = tools.isJSON(data.objList[field]?.business?.fieldExt) && JSON.parse(data.objList[field]?.business?.fieldExt);
      list = data.filterType?.[data.objList[field]?.business?.fieldType]?.[businessFieldExt?.type];
    } else {
      if ([12, 25].includes(fieldType)) {
        list = data.filterType?.[data.objList[field]?.business?.fieldType]?.filter((d) => ['null', 'not_null'].includes(d.value)) || [];
      } else {
        list = data.filterType?.[data.objList[field]?.business?.fieldType];
      }
    }
  } else {
    if (data.objList[field]?.fieldType == 24) {
      const fieldExt = tools.isJSON(data.objList[field]?.fieldExt) && JSON.parse(data.objList[field]?.fieldExt);
      list = data.filterType?.[data.objList[field]?.fieldType]?.[fieldExt?.type];
    } else {
      if ([12, 25].includes(fieldType)) {
        list = data.filterType?.[data.objList[field]?.fieldType]?.filter((d) => ['null', 'not_null'].includes(d.value)) || [];
      } else {
        list = data.filterType?.[data.objList[field]?.fieldType] || [];
      }
    }
  }
  return list;
};
// 日期类型获取日期变量
const getDateVariable = (record, index) => {
  console.log(274, record, index);
  data.form.conditions[index].value = record;
};
const records = ref(JSON.parse(JSON.stringify(props.record)));
const findRecordsContent = ref();
const data = reactive({
  orgId: userInfo?.orgId, //组织id
  entityObj: inject('flowStepParams')?.entityObj,
  entityId: inject('flowStepParams')?.entity,
  triggerAction: inject('flowStepParams')?.triggerAction,
  recording: inject('flowStepParams')?.recording,
  selected: [
    { label: t('所有'), value: true },
    { label: t('任一'), value: false }
  ],
  form: {
    queryAll: records.value.queryAll ?? true,
    conditions: [{ id: undefined, operation: '', isGroup: false, parentId: undefined, field: '', value: null, fieldType: null }]
  },
  cascaderList: [],
  createUser: [],
  numberList: [],
  priceList: [],
  percentageList: [],
  leadsFieldList: [],
  objList: {},
  filterType: inject('engineGlobal')?.filterType,
  fieldNames: { value: 'fieldKey', label: 'fieldName' }
});
const addCondition = () => {
  data.form.conditions.push({ id: undefined, operation: '', isGroup: false, parentId: undefined, field: '', value: null, fieldType: null });
  nextTick(() => {
    if (findRecordsContent.value) {
      findRecordsContent.value.scrollTo({
        top: findRecordsContent.value.scrollHeight,
        behavior: 'smooth'
      });
    }
  });
};
const deleteItem = (index) => {
  data.form.conditions.splice(index, 1);
};
const changeChild = (e, index) => {
  console.log(448, e, index, data.objList[e]);
  // const fk = data.leadsFieldList.find((v) => v.fieldKey === e).fieldExt;
  data.form.conditions[index].operation = '';
  data.form.conditions[index].value = null;
  data.form.conditions[index].userDept = [];
  data.form.conditions[index].departList = [];
  data.form.conditions[index].userList = [];
  data.form.conditions[index].fieldType = data.objList[e]?.fieldType;
  data.form.conditions[index].fieldExt = data.objList[e]?.fieldType == 12 ? data.objList[e]?.fieldExt : null;
};
const changeChildTwo = (e, index) => {
  console.log(e, index);
  data.form.conditions[index].value = '';
  data.form.conditions[index].userDept = [];
  data.form.conditions[index].departList = [];
  data.form.conditions[index].userList = [];
};
const getValUser = (v, index) => {
  const userNames = computed(() => v?.userList?.map((u) => u.userName));
  const departNames = computed(() => v?.departList?.map((u) => u.departmentName));
  data.form.conditions[index].userDept = [...userNames.value, ...departNames.value];
  data.form.conditions[index].userList = v.userList;
  data.form.conditions[index].departList = v.departList;
  const userIds = computed(() => data.form.conditions[index].userList.map((c) => c.id));
  const departIds = computed(() => data.form.conditions[index].departList.map((c) => c.id));
  data.form.conditions[index].value = JSON.stringify({
    userIds: userIds.value,
    departIds: departIds.value
  });
};
// 自动化流程引擎对字段的特殊处理
const sysField = ['gmtUpdated', 'lastUpdateUser', 'lastUpdateTime', 'updateUser'];
// 获取条件下字段类型
const init = async () => {
  try {
    data.form.conditions = [{ id: undefined, operation: '', isGroup: false, parentId: undefined, field: '', value: null, fieldType: null }];
    let objEntity = [];
    if (data.entityObj[data.entityId]?.length) {
      objEntity = data.entityObj[data.entityId]?.filter((v) => v.fieldType !== 18 && !(v.fieldType === 21 && v.business?.fieldType === 18));
    } else {
      const res = await setService.getEntitySettings({ entity: data.entityId, apiIndex: tools.randomString() }); //查询entity所有字段
      objEntity = res.result?.filter((v) => v.fieldType !== 18 && !(v.fieldType === 21 && v.business?.fieldType === 18));
    }
    // 自动化的特殊处理
    data.leadsFieldList = objEntity?.filter((v) => v.isEnabled !== false && ![27].includes(v.fieldType) && !sysField.includes(v.fieldKey || v?.business?.fieldKey)); //第一个框
    objEntity?.forEach((item) => {
      data.objList[item.fieldKey] = item;
    });
    console.log(256, data.leadsFieldList);
    data.cascaderList = data.leadsFieldList.filter((item) => item.fieldType === 10 || item?.business?.fieldType === 10).map((item) => item.fieldKey);
    data.createUser = data.leadsFieldList.filter((item) => item.fieldType === 6 || item?.business?.fieldType === 6 || item.fieldType === 22 || item?.business?.fieldType === 22).map((item) => item.fieldKey);
    // 数字key集合
    data.numberList = data.leadsFieldList.filter((item) => item.fieldType === 7 || item?.business?.fieldType === 7 || (item.fieldType == 24 && tools.isJSON(item.fieldExt) && [5, 7]?.includes(JSON.parse(item.fieldExt).type)) || (item?.business?.fieldType == 24 && tools.isJSON(item?.business?.fieldExt) && [5, 7]?.includes(JSON.parse(item?.business?.fieldExt).type)) || (item?.business?.fieldType == 24 && tools.isJSON(item?.business?.fieldExt) && [5, 7]?.includes(JSON.parse(item?.business?.fieldExt).type))).map((item) => item.fieldKey);
    // 金额key集合
    data.priceList = data.leadsFieldList.filter((item) => item.fieldType === 16 || item?.business?.fieldType === 16 || (item.fieldType == 24 && tools.isJSON(item.fieldExt) && [6, 16]?.includes(JSON.parse(item.fieldExt).type)) || (item?.business?.fieldType == 24 && tools.isJSON(item?.business?.fieldExt) && [6, 16]?.includes(JSON.parse(item?.business?.fieldExt).type)) || (item?.business?.fieldType == 24 && tools.isJSON(item?.business?.fieldExt) && [6, 16]?.includes(JSON.parse(item?.business?.fieldExt).type))).map((item) => item.fieldKey);
    // 百分比对象集合
    data.percentageList = data.leadsFieldList?.filter((item) => item.fieldType === 23 || item?.business?.fieldType === 23 || (item.fieldType == 24 && tools.isJSON(item.fieldExt) && [23]?.includes(JSON.parse(item.fieldExt).type)) || (item?.business?.fieldType == 24 && tools.isJSON(item?.business?.fieldExt) && [23]?.includes(JSON.parse(item?.business?.fieldExt).type)));
  } catch (e) {
    console.log(e);
  }
};
// 数据处理
const updateSettingField = async () => {
  const arr = JSON.parse(JSON.stringify(data.form));
  arr.conditions.forEach((item) => {
    if (Array.isArray(item.value) && (item.operation === 'in' || item.operation === 'not_in')) {
      if (Array.isArray(item.value[0]) && data.cascaderList?.includes(item.field)) {
        item.value = item.value.map((subArr) => subArr.join('/')).join(',');
      } else {
        if (Array.isArray(item.value)) {
          item.value = item.value.filter(Boolean).join(',');
        }
      }
    } else if (Array.isArray(item.value) && item.operation === 'between') {
      const obj = {
        beginDate: item.value[0],
        endDate: item.value[1]
      };
      const jsonObj = JSON.stringify(obj);
      item.value = jsonObj;
    } else if ((Array.isArray(item.value) && item.operation == 'equals') || item.operation == 'not_equals') {
      if (data.cascaderList?.includes(item.field) && Array.isArray(item.value)) {
        item.value = item.value.join('/');
      }
    }
    if (data.priceList?.includes(item.field) && item.operation != 'null' && item.operation != 'not_null') {
      item.value = item.value * 10000;
    }
    // 处理百分比字段类型
    if (data.percentageList?.length) {
      data.percentageList.forEach((v) => {
        // 此处v?.fieldKey ===item.field,其他组件可能是v?.field ==item.field,注意！注意！注意！！！！！
        if (v?.fieldKey === item.field && item.operation != 'null' && item.operation != 'not_null') {
          if (item.value && !isNaN(Number(item.value))) {
            let fieldExt = '';
            if (v.fieldType === 21) {
              if (v.fieldType === 24) {
                fieldExt = (tools.isJSON(v?.business?.fieldExt) && JSON.parse(v?.business?.fieldExt)?.dataType) || 2;
              } else {
                fieldExt = (tools.isJSON(v?.business?.fieldExt) && JSON.parse(v?.business?.fieldExt)?.numberFormat) || 2;
              }
            } else {
              if (v.fieldType === 24) {
                fieldExt = (tools.isJSON(v?.fieldExt) && JSON.parse(v?.fieldExt)?.dataType) || 2;
              } else {
                fieldExt = (tools.isJSON(v?.fieldExt) && JSON.parse(v?.fieldExt)?.numberFormat) || 2;
              }
            }
            item.value = tools.setPercentage(item.value, fieldExt);
          }
        }
      });
    }
  });
  console.log(322, arr?.conditions, props.isQueryAll);
  if (props.isQueryAll) {
    emits('cb', arr);
  } else {
    emits('cb', arr?.conditions);
  }
};
//回显
const getConditions = async () => {
  await init();

  const res = records.value;
  if (res.conditions == null) {
    data.form.conditions = [{ id: undefined, operation: '', isGroup: false, parentId: undefined, field: '', value: null, fieldType: null }];
  } else {
    res.conditions?.forEach((item, index) => {
      if (data.createUser.includes(item.field) && item.operation != 'null' && item.operation != 'not_null') {
        const dept = item.value?.departIds?.map((v) => v.name) || [];
        const user = item.value?.userIds?.map((v) => v.name) || [];
        const userIds = item.value?.userIds?.map((v) => v.id);
        const departIds = item.value?.departIds?.map((v) => v.id);
        res.conditions[index].userDept = [...dept, ...user];
        res.conditions[index].userList = item.value?.userIds?.map((v) => {
          return {
            ...v,
            userName: v.name,
            avatarOrigin: v.avatar
          };
        });
        res.conditions[index].departList = item.value?.departIds?.map((v) => {
          return {
            ...v,
            departmentName: v.name,
            avatarOrigin: v.avatar
          };
        });
        res.conditions[index].value = JSON.stringify({
          userIds: userIds,
          departIds: departIds
        });
      }
      if (item.operation == 'in' || item.operation == 'not_in') {
        if (data.cascaderList?.includes(item.field) && item.value?.includes('/')) {
          item.value = item.value?.split(',').map((str) => str.split('/'));
        } else {
          item.value = item?.value?.split(',');
        }
      } else if (item.fieldType == 9 && item.operation == 'between') {
        // 在区间（日期类型）
        const parsedObject = JSON.parse(item.value);
        const datesArray = [parsedObject.beginDate, parsedObject.endDate];
        item.value = datesArray;
      } else if (data.cascaderList?.includes(item.field) && (item.operation == 'equals' || item.operation == 'not_equals')) {
        item.value = item.value?.split('/');
      } else {
        // 兼容一下日期类型的数据，如果返回的是数组就变成字符串
        item.value = Array.isArray(item.value) ? item.value.join() : item.value;
      }
      if (data.numberList.includes(item.field) && item.operation != 'null' && item.operation != 'not_null') {
        if (item.value && !isNaN(Number(item.value))) item.value = Number(item.value);
      }
      if (data.priceList.includes(item.field) && item.operation != 'null' && item.operation != 'not_null') {
        if (item.value && !isNaN(Number(item.value))) item.value = Number(item.value) / 10000;
      }
      // 百分比
      console.log(406, data.percentageList, item);
      if (data.percentageList?.length) {
        data.percentageList.forEach((v) => {
          // 此处v?.fieldKey ===item.field,其他组件可能是v?.field ==item.field,注意！注意！注意！！！！！
          if (v?.fieldKey === item.field && item.operation != 'null' && item.operation != 'not_null') {
            if (item.value && !isNaN(Number(item.value))) {
              let fieldExt = '';
              if (v.fieldType == 21) {
                if (v?.business?.fieldType == 24) {
                  fieldExt = (tools.isJSON(v?.business?.fieldExt) && JSON.parse(v?.business?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(v?.business?.fieldExt) && JSON.parse(v?.business?.fieldExt)?.numberFormat) || 2;
                }
              } else {
                if (v.fieldType == 24) {
                  fieldExt = (tools.isJSON(v?.fieldExt) && JSON.parse(v?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(v?.fieldExt) && JSON.parse(v?.fieldExt)?.numberFormat) || 2;
                }
              }
              item.value = tools.getPercentage(item.value, fieldExt);
            }
          }
        });
      }
    });
    data.form = res;
  }
};
// const userTree = ref({
//   checkDepartment: false,
//   isAll: false
// });
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
watch(
  () => data.entityId,
  () => {
    init();
  },
  { deep: true }
);
watch(
  () => data.form,
  () => {
    updateSettingField();
  },
  { deep: true }
);
watch(
  () => props.record,
  () => {
    records.value = JSON.parse(JSON.stringify(props.record));
    getConditions();
  },
  { deep: true, immediate: true }
);
</script>
<style scoped lang="less">
@import './find-field-condition.less';
</style>
